// generated/models/responsiveNotePhotoMappingStatus.ts
var ResponsiveNotePhotoMappingStatus = {
  pending: "pending",
  mapped: "mapped",
  unmapped: "unmapped"
};

export {
  ResponsiveNotePhotoMappingStatus
};
//# sourceMappingURL=chunk-E4YWTFU3.mjs.map